<div>
    <mat-toolbar style="background: {{this.dashcolor}}" class="footer">

    </mat-toolbar>
</div>
